import { LuxeMonogramMark } from "@/components/luxe/LuxeMonogramMark";

export const PortraitPlaceholderPlate = ({ letters = "SS", caption = "Portrait coming soon", className = "", testId }) => (
  <div
    data-testid={testId}
    data-luxe-noise="true"
    className={`flex h-full w-full flex-col items-center justify-center gap-5 bg-[linear-gradient(160deg,hsl(348_70%_95%),hsl(345_55%_88%))] ${className}`}
  >
    <div className="relative z-[1] flex flex-col items-center gap-5">
      <LuxeMonogramMark letters={letters} size="lg" />
      <span className="eyebrow text-[10px] text-muted-foreground">{caption}</span>
    </div>
  </div>
);
